import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, Validators, UntypedFormControl } from "@angular/forms";
import { FrontDesk } from "src/app/models/frontDesk";
import { Router, ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { VproService } from "src/app/service/vpro/vpro.service";
import { Utils } from "src/app/common/utils";
import Swal from "sweetalert2";
import { Location } from '@angular/common';

declare var $: any;
@Component({
  selector: "app-edit-fdesk-profile",
  templateUrl: "./edit-fdesk-profile.component.html",
  styleUrls: ["./edit-fdesk-profile.component.css"],
})
export class EditFdeskProfileComponent implements OnInit {
  editFdeskCurrentTab: string = "personalInformation";
  editFdeskListOfTabs: string[] = ["personalInformation"];

  user: FrontDesk = new FrontDesk();
  forms = {
    personalInformation: null,
  };

  ppfile: File = null;
  isEdited: Boolean = false;
  fdeskname: string;
  avatartimg: any;
  constructor(
    private service: VproService,
    private route: ActivatedRoute,
    private _formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService,
    private location: Location
  ) { }

  ngOnInit() {
    this.forms.personalInformation = this._formBuilder.group({
      address_1: [null],
      address_2: [null],
      additional_info: [null],
      u_id: [null],
      contact_no: [
        null,
        [
          Validators.pattern(Utils.numberRegex),
          Validators.maxLength(12),
          Validators.minLength(10),
        ],
      ],
      ppurl: [null],
      pp_content_type: [null],
    });

    this.loadUser();
  }

  loadUser() {
    this.spinner.show();
    this.service.getFrontDeskById(this.route.snapshot.params["id"]).subscribe(
      (response) => {
        this.spinner.hide();
        if (response) {
          this.user = response;
          this.forms.personalInformation.patchValue(this.user);
          this.fdeskname = this.user.first_name + ' ' + this.user.last_name;
          this.avatartimg = this.user.ppurl.substring(this.user.ppurl.lastIndexOf('/') + 1);
          if (this.avatartimg == "img_avatar.png")
            this.user.ppurl = ""
        }
      },
      (error) => {
        this.spinner.hide();
        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 3500,
        });
        Toast.fire({
          type: "error",
          title: "Something went wrong. Please try again later.",
        });
      }
    );
  }

  getControl(field: string): UntypedFormControl {
    return this.forms.personalInformation.get(field) as UntypedFormControl;
  }

  updateField(field: string) {
    const control = this.getControl(field);

    if (control.valid) {
      this.user = {
        ...this.user,
        [field]: control.value,
      };
    }
  }

  /** Function to update Front desk data */
  public saveFrontDesk(): void {
    // Create the JSON to be send to backend
    let data = {
      ...this.forms.personalInformation.value,
    };
    // Remove any empy fields
    data = Utils.removeNullAndEmpty(data);
    if (!this.isEdited) {
      delete data.ppurl;
      delete data.pp_content_type;
    }
    data["org_code"] = localStorage.getItem("orgcode");
    // console.log(data);
    this.spinner.show();
    this.service.updateFrontDesk(this.user.u_id, data, this.ppfile).subscribe(
      (res) => {
        this.spinner.hide();
        // SweetAlert

        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 3500,
        });

        Toast.fire({
          type: "success",
          title: "Front-desk profile has been updated successfuly",
        });
      },
      (error) => {
        this.spinner.hide();
        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 3500,
        });
        Toast.fire({
          type: "error",
          title: "Something went wrong. Please try again later.",
        });
      }
    );
  }

  getback() {
    this.location.back();
  }

  get f() {
    return this.forms[this.editFdeskCurrentTab].controls;
  }

  public fileSelected(event) {
    if (event.target.files[0].type && event.target.files[0].type.indexOf('image') === -1 || !Utils.allowedImageFormats.includes(event.target.files[0].type.split('/').pop())) {
      const Toast = Swal.mixin({
        position: 'top',
        showConfirmButton: true,
        allowOutsideClick: false,


      });

      Toast.fire({
        type: 'warning',
        title: 'Only .png/.jpeg/.jpg format is allowed',

      });

    }
    else {

      if (event.target.files && event.target.files[0]) {
        const reader = new FileReader();

        reader.readAsDataURL(event.target.files[0]); // read file as data url

        reader.onload = (e: Event) => {
          // called once readAsDataURL is completed
          // console.log("inside on load", e);
          if (e && e.target && e.target["result"]) {
            this.user.ppurl = e.target["result"];
          }
        };

        // now update ppurl file to send in api
        this.ppfile = event.target.files[0];
        this.forms.personalInformation.patchValue({
          ppurl: event.target.files[0].name,
          pp_content_type: event.target.files[0].type,
        });

        this.isEdited = true;
      }
    }
  }
}
